import { Component } from '@angular/core';
import { Metadata, SearchCriteria } from '../../search/models/search-filter-model';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { SearchService } from '../../search/search.service';
import { AlertService } from 'sce-core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { ResourceService } from 'sce-core';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { ModalService } from '../../services/modal.service';
import { ButtonItem } from '../../button/button.model';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { TransferDataService } from '../../../features/inventory/vas/transfer/services/transfer-data.service';
import { COLUMN_NAMES, POPULATE_TYPES, TABLE_NAMES } from '../../../constants';

@Component({
  selector: 'lfwms-populate-popup',
  templateUrl: './populate-popup.component.html',
  styleUrls: ['./populate-popup.component.css']
})
export class PopulatePopupComponent {

  private metaData: Metadata;
  public lookupParams: SearchParams;
  public lookupStatus: SearchStatus;
  public lookupService: SearchService;
  public showLookup: boolean = false;
  private defaultSearchCriteria: SearchCriteria;
  public lookupAlertService: AlertService;
  public title: string;
  public eventSubject = new Subject<any>();
  public type: any;
  public totalQty: number = 0; // JIRA [LFWM-1919] - totalQty = sum of qty of selected rows
  public defaultTdForSearch: any; // LFWM-2442 - get default td when user toggle between
  public showTotal: boolean = false;
  //public dataService: TransferDataService;
  public parentDataService: any;
  // populate from archive check box

  constructor(public modalService: ModalService,
    private resourceService: ResourceService,
    protected sharedServiceRegistry: SharedServiceRegistry,
    protected coreServiceRegistry: CoreServiceRegistry) {
    this.lookupAlertService = new AlertService();
    this.eventSubject = new Subject<any>();
  }

  // method used to translate the labels
  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public initializeComponents(lookupParams, type, lookupStatus, searchCriteria, dataService?) {
    this.parentDataService = dataService;
    this.lookupParams = lookupParams;
    this.type = type;
    this.lookupParams.alertService = this.lookupAlertService;
    // Data editor is needed  for tableheader filter to work.
    this.lookupParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    if (type === 'Invtransfer' ) {
      this.lookupParams.actionButtons = [new ButtonItem('Populate', this.resourceService.get('lbl_populate'), 'asn_pop', 'icon_populate.svg', []),
      new ButtonItem('PopulateAll', this.resourceService.get('btn_populate_transfer_all'), 'vas_trnsfr_pop_all', 'icon_populate.svg', [])
      ];
    }
    // LFWM-4304 - Populate all for Inventory Adjustment
    else if (type === 'Adjustment') {
      this.lookupParams.actionButtons = [
        new ButtonItem('Populate', this.resourceService.get('lbl_populate'), 'asn_pop', 'icon_populate.svg', []),
        new ButtonItem('PopulateAll_Adjustment', this.resourceService.get('btn_populate_adjustment_all'), 'inv_adj_pop_all', 'icon_populate.svg', [])
      ];
    }
     // LFWM-3966 - Populate all for Inventory QC from LotxLocxId
     else if (type === 'LotxLocxId') {
      this.lookupParams.actionButtons = [
        new ButtonItem('Populate', this.resourceService.get('lbl_populate'), 'asn_pop', 'icon_populate.svg', []),
        new ButtonItem('PopulateAll_LotxLocxId', this.resourceService.get('lbl_populate_all'), 'inv_qc_pop_all', 'icon_populate.svg', [])
      ];
    } else if (type === COLUMN_NAMES.UCC) {
      this.lookupParams.actionButtons = [
        new ButtonItem(POPULATE_TYPES.POPULATE_UCC, this.resourceService.get('lbl_populate'), 'asn_pop', 'icon_populate.svg', []),
        new ButtonItem(POPULATE_TYPES.POPULATE_ALL_UCC, this.resourceService.get('lbl_populate_all'), 'vas_trnsfr_pop_all_ucc', 'icon_populate.svg', [])
      ];
    } else {
      this.lookupParams.actionButtons = [
        new ButtonItem('Populate', this.resourceService.get('lbl_populate'), 'asn_pop', 'icon_populate.svg', [])];
    }
    // this.buttonService.getButtonsForPanel('search-table');
    this.lookupService = this.sharedServiceRegistry.createSearchService(lookupParams, lookupStatus);
    this.lookupStatus = this.lookupService.searchStatus;
    this.lookupService.setSearchCriteria(searchCriteria);
    // LFWM-2442 - variable to store the default td and use when user toggle the  populate From Archive DB checkbox
    this.defaultTdForSearch = this.lookupParams.tableId;
  }

  // JIRA LFWM-1162 - Enabling Populate from Archive DB checkbox for Populate PO Popup
  public toggleCheckbox() {
    this.lookupParams.fetchArchiveRecords = (this.lookupParams.fetchArchiveRecords === false) ? true : false;
    // LFWM-2442 -This is workaround if order details then the table should be populateodarchivetd to fix the
    // search functionality
    if (this.type === 'OrderDetail') {
      this.lookupParams.tableId = (this.lookupParams.fetchArchiveRecords === true) ? 'populateodarchivetd' : this.defaultTdForSearch;
    } else if (this.type === 'PO') {
      //lfwm-3019 added the code for changing table id to archive table id on calling in archive mode
      this.lookupParams.tableId = (this.lookupParams.fetchArchiveRecords === true) ? 'populatepoarchivetd' : this.defaultTdForSearch;
    }
  }

  public handlePopulateAction() {
    const selectedRows = this.lookupService.getSelectedRows();

    if (selectedRows.length === 0) {
      this.lookupAlertService.error(this.resourceService.get('msg_sel_detail'));
      return;
    }

    const requiredDetailsToPopulateLineItems = [];
    switch (this.type) {
      case 'PO': {
        // From ASN or Inbound XDock or Outbound XDock Screen - [Populate Po Detail] button
        selectedRows.forEach(row => {
          requiredDetailsToPopulateLineItems.push({ poKey: row.cells['poKey'].cVal, poLineNo: row.cells['poLineNumber'].cVal });
        });
        break;
      }
      case 'OrderDetail': {
        // From Trade Returns or Inbound XDock or Outbound XDock Screen - [Populate Order Detail] button
        selectedRows.forEach((row: any) => {
          requiredDetailsToPopulateLineItems.push({ orderKey: row.cells['orderKey'].cVal, orderLineNo: row.cells['orderLineNumber'].cVal });
        });
        break;
      }
      case 'Order':
      case 'WaveOrder': {
        // type - Order - From Trade Returns or Inbound XDock or ASN - [Populate Order] button
        // type - WaveOrder - From Wave Control - [Populate Order] button
        selectedRows.forEach((row: any) => {
          requiredDetailsToPopulateLineItems.push(row.cells['orderKey'].cVal);
        });
        break;
      }
      case 'Invtransfer': {
        if (this.lookupParams.tableId === 'POPULATEADJTD') {
          selectedRows.forEach((row: any) => {
            requiredDetailsToPopulateLineItems.push({
              lot: row.cells['lot'].cVal,
              loc: row.cells['loc'].cVal,
              id: row.cells['id'].cVal,
              facility: row.cells['facility'].cVal,
              storerKey: row.cells['storerKey'].cVal
            });
          });
        }
        break;
      }      
      case 'Adjustment': {
        // From Inventory Adjustment or Transfer Screen - [Populate Adjustment] button
        if (this.lookupParams.tableId === 'POPULATEADJTD') {
          selectedRows.forEach((row: any) => {
            requiredDetailsToPopulateLineItems.push({
              lot: row.cells['lot'].cVal,
              loc: row.cells['loc'].cVal,
              id: row.cells['id'].cVal,
              facility: row.cells['facility'].cVal,
              storerKey: row.cells['storerKey'].cVal
            });
          });
        } else if (this.lookupParams.tableId === 'POPULATEUCCTD') {
          // From UCC Adjustment Screen - [Populate From UCC] button
          selectedRows.forEach((row: any, index) => {
            requiredDetailsToPopulateLineItems.push(
              {                
                uccNo: row.cells['uccNo'].cVal,
                storerKey: row.cells['storerKey'].cVal,
                facility: row.cells['facility'].cVal,
                SearchCriteria: this.formatSearchCriteria(this.lookupService.getSearchCriteria())
              });
          });
        }
        break;
      }
      case 'A':
      case 'R': {
        selectedRows.forEach((row: any) => {
          requiredDetailsToPopulateLineItems.push({
            storerKey: row.cells['storerKey'].cVal.trim(),
            sku: row.cells['sku'].cVal.trim(),
            pack: row.cells['packKey'].cVal.trim(),
            qty: Number(row.cells['expectedQty'].cVal.trim()),
            toLoc: row.cells['toLoc'].cVal.trim(),
            receiptKey: row.cells['receiptKey'].cVal.trim(),
            receiptLineNumber: row.cells['receiptLineNumber'].cVal.trim(),
            toId: row.cells['toId'].cVal
          });
        });
        break;
      }
      case 'Kitting': {
        // From Kitting Screen - [From Detail List or To Detail List] - [Populate KIT] button
        requiredDetailsToPopulateLineItems.push(selectedRows);
        // for kitting most of the data is needed to form the request
        break;
      }
      case 'LotxLocxId': {
        /* JIRA [LFWM-1919] - this section is added for [Populate From LotxLocxId in Inventory QC screen to
      populate line items using lot,loc,id values */
        selectedRows.forEach((row: any) => {
          requiredDetailsToPopulateLineItems.push({
            lot: row.cells['lot'].cVal,
            loc: row.cells['loc'].cVal,
            id: row.cells['id'].cVal,
          });
        });
        break;
      }
      case 'UCC': {
        /* JIRA [LFWM-2208] - this section is added for [Populate Transfer by UCC in Transfer screen to
        populate line items using uccRowRef */
        selectedRows.forEach((row: any) => {
          requiredDetailsToPopulateLineItems.push(row.cells['uccRowRef'].cVal);
        });
        break;
      }
    }
    const populateEvent = {
      'type': 'populate', 
      'selectedItems': requiredDetailsToPopulateLineItems,
      'populateFromArchive': this.lookupParams.fetchArchiveRecords
    };
    this.notifyEvent(populateEvent);

  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }

  /* JIRA [LFWM-1919] - Inventory QC - Populate From LotxLocxId-this method is used to calculate total quantity of selected rows
  event is captured from result data table component on select of checkbox
  [LFWM-2208] - adding one more check - [type-UCC] - total qty should be displayed in Populate Transfer by UCC from Transfer Screen */
  // [LFWM-4327][Prod & Uat - AU | UCC adjustment Qty not populated]
  public onSelectCheckbox() {
    const selectedRows: any[] = this.lookupService.getSelectedRows();
    this.totalQty = 0;
    if (this.type === 'LotxLocxId' || this.type === 'UCC') {
      if (selectedRows.length > 0) {
        selectedRows.forEach(row => {
          this.totalQty += parseInt(row.cells['qty'].cVal, 10);
        });
      }
      // [LFWM-2973][To calculate the total Quantity if type ='Adjustment']
    } 
    // [LFWM-4445][To calculate the total Quantity if type ='InvTransfer']
    else if(this.type === 'Invtransfer' || this.type === 'Adjustment'){
      if (selectedRows.length > 0) {
        selectedRows.forEach(row => {
          const qty = row.cells['Quantity'] ? row.cells['Quantity'].cVal : row.cells['qty'].cVal;
          this.totalQty += parseInt(qty, 10);
        });
      }
    }
  }

  /* LFWM-1933 -- Standardize the populate button location.
  Moved populate button from bottom to top of results table.
  Below method is called from <lfwms-result-data-table>
  (buttonActionHandler) on clicking any buttons above table
  */
  public handleButtonAction($event) {
    // Currently only populate button
    if ($event === 'Populate') {
      this.handlePopulateAction();
    }
    if ($event === 'PopulateAll') {
      //this.handlePopulateAction();

      const noOfLineItems = this.lookupService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const request: any = {
        'transferkey': this.parentDataService.primaryDataMap['transferKey'].cVal,
        'searchRequest': {
          'pageInfo': {
            'tableId': 'POPULATEADJTD',
            'pageNo': 1,
            'sortColumn': null,
            'sortOrder': 0,
            'pageSize': 1,
            'fullFetch': true,
            'fetchAllrecords': true,
            'fetchArchiveRecords': false
          },
          'searchCriteria': this.formatSearchCriteria(this.lookupService.getSearchCriteria())
        },

      };
      const populateEvent = {
        'type': 'populateAll',
        'request': request

      };
      this.notifyEvent(populateEvent);
    }
    // LFWM-4304 - Populate all for Inventory Adjustment
    if ($event === 'PopulateAll_Adjustment') {
      const noOfLineItems = this.lookupService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const request: any = {
        'adjustmentkey': this.parentDataService.primaryDataMap['adjustmentKey'].cVal,
        'tableId': 'POPULATEADJTD',
        'searchRequest': {
          'pageInfo': {
            'tableId': 'POPULATEADJTD',
            'pageNo': 1,
            'sortColumn': null,
            'sortOrder': 0,
            'pageSize': 1,
            'fullFetch': true,
            'fetchAllrecords': false,
            'fetchArchiveRecords': false
          },
          'searchCriteria': this.formatSearchCriteria(this.lookupService.getSearchCriteria())
        },
      };
      const populateEvent = {
        'type': 'populateAll',
        'request': request

      };
      this.notifyEvent(populateEvent);
    }
    // LFWM-3966 - Populate all for Inventory QC from LotxLocxId
    if ($event === 'PopulateAll_LotxLocxId') {
      const noOfLineItems = this.lookupService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const request: any = {
        'key': this.parentDataService.primaryDataMap['qcKey'].cVal,
        'tableId': 'populatelotlocidtd',
        'searchRequest': {
          'pageInfo': {
            'tableId': 'populatelotlocidtd',
            'pageNo': 1,
            'sortColumn': null,
            'sortOrder': 0,
            'pageSize': 1,
            'fullFetch': true,
            'fetchAllrecords': true,
            'fetchArchiveRecords': false
          },
          'searchCriteria': this.formatSearchCriteriaForAll(this.lookupService.searchCriteria, this.lookupParams.additionalParamMap, this.lookupService.filterCondition)
        },
      };
      const populateEvent = {
        'type': 'populateAll',
        'request': request

      };
      this.notifyEvent(populateEvent);
    }
    if ($event === POPULATE_TYPES.POPULATE_ALL_UCC) {
      const noOfLineItems = this.lookupService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const request: any = {
        'transferkey': this.parentDataService.primaryDataMap[COLUMN_NAMES.TRANSFER_KEY].cVal,
        'tableId': TABLE_NAMES.POPULATE_TRANSFER_UCC,
        'searchRequest': {
          'pageInfo': {
            'tableId': TABLE_NAMES.POPULATE_TRANSFER_UCC,
            'pageNo': 1,
            'sortColumn': null,
            'sortOrder': 0,
            'pageSize': 1,
            'fullFetch': true,
            'fetchAllrecords': true,
            'fetchArchiveRecords': false
          },
          'searchCriteria': this.formatSearchCriteriaForAll(this.lookupService.searchCriteria, this.lookupParams.additionalParamMap, this.lookupService.filterCondition)
        },

      };
      const populateEvent = {
        'type': POPULATE_TYPES.POPULATE_ALL,
        'request': request

      };
      this.notifyEvent(populateEvent);
    
    }
  }

  public formatSearchCriteriaForAll(searchCriteria, additionalParamMap, filterCondition?: any) {
      if (!searchCriteria) {
        return {};
      }
      let allConditions = null;
      // Code added to merge filter conditions with master search criteria, if filter condition is there.
      if (filterCondition && filterCondition.clauses.length > 0) {
        allConditions = JSON.parse(JSON.stringify(searchCriteria.conditions));
        if (allConditions && allConditions.length > 0) {
          allConditions[allConditions.length - 1].operator = 'AND';
        }
        allConditions.push(filterCondition);
      } else {
        allConditions = searchCriteria.conditions;
      }
      const conditionReqList = [];
      allConditions.forEach((condition: any, index: any) => {
        const clauseReqlist = [];
        condition.clauses.forEach((clause: any) => {
          if (clause.value !== undefined && clause.value !== null) {
            clauseReqlist.push({
              column: clause.column,
              operation: clause.operation,
              value: clause.value,
              value1: clause.value1,
              logicalOperation: clause.logicalOperation
            });
          }
        });
        if (clauseReqlist.length !== 0) {
          let logOp = null;
          if (index < allConditions.length - 1) {
            logOp = condition.operator;
          }
          conditionReqList.push({
            mandatory: condition.isMandatory,
            clauses: clauseReqlist,
            logicalOperation: logOp
          });
        }
      });
      if (additionalParamMap) {
        const additionalClauses = [];
        const additionalParams = additionalParamMap;
        const additionalProps = Object.keys(additionalParams);
        if (additionalProps.length > 0) {
          const lastCondition = conditionReqList.slice(conditionReqList.length - 1)[0];
          lastCondition.logicalOperation = 'AND';
          additionalProps.forEach((property: string, index: number) => {
            additionalClauses.push({
              column: property,
              operation: '=',
              value: additionalParams[property],
              logicalOperation: index === 0 ? '' : 'AND'
            });
          });
          conditionReqList.push({
            mandatory: false,
            clauses: additionalClauses,
            logicalOperation: ''
          });
        }
      }
      return { conditions: conditionReqList };  
  }
  
  public formatSearchCriteria(searchCriteria) {
    if (!searchCriteria) {
      return {};
    }
    let allConditions = null;
    // Code added to merge filter conditions with master search criteria, if filter condition is there.
    allConditions = searchCriteria.conditions;

    const conditionReqList = [];
    allConditions.forEach((condition: any, index: any) => {
      const clauseReqlist = [];
      condition.clauses.forEach((clause: any) => {
        if (clause.value !== undefined && clause.value !== null) {
          clauseReqlist.push({
            column: clause.column,
            operation: clause.operation,
            value: clause.value,
            value1: clause.value1,
            logicalOperation: clause.logicalOperation
          });
        }
      });
      if (clauseReqlist.length !== 0) {
        let logOp = null;
        if (index < allConditions.length - 1) {
          logOp = condition.operator;
        }
        conditionReqList.push({
          mandatory: condition.isMandatory,
          clauses: clauseReqlist,
          logicalOperation: logOp
        });
      }
    });
    return { conditions: conditionReqList };
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/populate-item-detail/populate-popup.component.ts